import cx from 'clsx';
import type { HTMLAttributes, ReactElement } from 'react';
import styles from '../popup.module.css';

export function PopupHeader({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>): ReactElement {
  return (
    <header className={cx(styles.header, className)} {...props}>
      {children}
    </header>
  );
}
